import React, { useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { generalAudioCaching } from '../../misc/tools';

import "./toggle.css"

const Toggle = (props: ToggleConfig) => {
	const [isToggled, setIsToggled] = useState(props.defaultIsEnabled);
	return (
		<div className='toggle-container' data-testid="test-toggle" onMouseEnter={() => {
			const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.click_04_01).src;
			Tools.playOneShotSound(url);
		}}  tabIndex={0} id={props.idFor508} aria-label={'Toggle ' + props.fieldName + '. Currently. ' + (isToggled ? 'on' : 'off')} onKeyUp={Tools.mapDivEnterToClick} onClick={() => {
			const toggled = !isToggled;
			const url = generalAudioCaching.getItemByKey(toggled ? generalAudioCaching.audioKeys.beep_short_on_01 : generalAudioCaching.audioKeys.beep_short_off_01).src;
			Tools.playOneShotSound(url);
			props.onToggled(toggled);
			setIsToggled(toggled);

		}}>
			<div className='toggle-bg'>
				<div className='toggle-fg center-element-vertical' style={
					isToggled ? {
						left: '35px'
					} : {

					}
				}>
				
				</div>
			</div>
		</div>
	);

};

export interface ToggleConfig {
	fieldName: string;
	defaultIsEnabled: boolean;
	onToggled: (state: boolean) => void;
	idFor508: string;
}

export default Toggle;